export const MAX_IN_RESTAURANT_CART_QUANTITY = 9;
export const MIN_IN_RESTAURANT_CART_QUANTITY = 1;
export const MAX_REWARDS_PER_CART = 0;
